export default __webpack_public_path__ + "static/media/640_business01-en-web.676972d0.png";